var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("modal-dialog", {
    attrs: {
      icon: _vm.$MDI.Motif,
      disabled: _vm.disabled,
      tooltip: "Find motifs based on ligand proximity",
    },
    scopedSlots: _vm._u([
      {
        key: "title",
        fn: function () {
          return [_vm._v("\n        Select Ligand-Based Motif\n    ")]
        },
        proxy: true,
      },
      {
        key: "toolbar-extra",
        fn: function () {
          return [
            _c(
              "v-icon",
              {
                on: {
                  click: function ($event) {
                    _vm.inSelection = false
                  },
                },
              },
              [_vm._v(_vm._s(_vm.$MDI.CloseCircle))]
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "text",
        fn: function () {
          return [
            _c(
              "div",
              { staticClass: "d-flex align-center mb-4" },
              [
                _c("span", { staticClass: "mr-4" }, [
                  _vm._v("Neighbor cutoff (Å)"),
                ]),
                _vm._v(" "),
                _c("v-slider", {
                  attrs: {
                    min: 2.0,
                    max: 8.0,
                    step: 0.5,
                    disabled: _vm.ligandMotifs.length === 0,
                    "thumb-label": "always",
                    "hide-details": "",
                  },
                  model: {
                    value: _vm.cutoff,
                    callback: function ($$v) {
                      _vm.cutoff = $$v
                    },
                    expression: "cutoff",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _vm.loading
              ? _c("v-progress-circular", {
                  staticClass: "d-block mx-auto my-4",
                  attrs: { indeterminate: "", color: "primary" },
                })
              : _vm.ligandMotifs.length === 0
              ? _c("div", { staticClass: "text-center my-4" }, [
                  _vm._v(
                    "\n            No ligands found in the structure.\n        "
                  ),
                ])
              : _c(
                  "v-list",
                  { staticClass: "ligand-motif-list", attrs: { dense: "" } },
                  _vm._l(_vm.ligandMotifs, function (item) {
                    return _c(
                      "v-list-item",
                      {
                        key: item.ligand,
                        staticClass: "motif-item",
                        on: {
                          click: function ($event) {
                            return _vm.selectMotif(item.motifString)
                          },
                        },
                      },
                      [
                        _c(
                          "v-list-item-content",
                          [
                            _c("v-list-item-title", [
                              _c("strong", [_vm._v("Ligand:")]),
                              _vm._v(
                                " " +
                                  _vm._s(item.ligand) +
                                  "\n                    "
                              ),
                            ]),
                            _vm._v(" "),
                            _c("v-list-item-subtitle", [
                              _c("strong", [
                                _vm._v(
                                  "Neighbors (" +
                                    _vm._s(item.neighbors.length) +
                                    "):"
                                ),
                              ]),
                              _vm._v(
                                " " +
                                  _vm._s(item.neighbors.join(", ")) +
                                  "\n                    "
                              ),
                            ]),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  }),
                  1
                ),
          ]
        },
        proxy: true,
      },
    ]),
    model: {
      value: _vm.inSelection,
      callback: function ($$v) {
        _vm.inSelection = $$v
      },
      expression: "inSelection",
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }